import { useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";
import {
  Trophy,
  IndianRupee,
  Copy,
  Check,
  MessageCircle,
  ShieldCheck,
  ArrowLeft,
} from "lucide-react";
import { Link } from "react-router-dom";

const UPI_ID = "kumaratul34702@okhdfcbank";
const PAYEE_NAME = "Atul Kumar";
const AMOUNT = 150;

const WHATSAPP_NUMBER = "919973532109";

export default function Payment() {
  const { id } = useParams();
  const location = useLocation();

  const [copied, setCopied] = useState(false);

  // Player name can be passed from registration
  const playerName = location.state?.playerName || "Player";

  const upiUrl =
    `upi://pay?pa=${encodeURIComponent(UPI_ID)}` +
    `&pn=${encodeURIComponent(PAYEE_NAME)}` +
    `&am=${AMOUNT}` +
    `&cu=INR`;

  const openUPIPayment = () => {
    window.location.href = upiUrl;
  };

  const copyUPI = async () => {
    try {
      await navigator.clipboard.writeText(UPI_ID);

      setCopied(true);

      setTimeout(() => {
        setCopied(false);
      }, 2000);
    } catch (error) {
      console.error("Copy failed:", error);
    }
  };

  const sendWhatsApp = () => {
    const message = `
🏏 BPL SEASON 2
Badgaw Premier League

💰 PLAYER REGISTRATION PAYMENT

Player ID: ${id}
Player Name: ${playerName}

Registration Fee: ₹150
Payment Status: Payment Done

UPI ID:
${UPI_ID}

I have completed my BPL Season 2 registration payment of ₹150.

Please verify my payment and approve my registration.
    `.trim();

    const whatsappUrl =
      `https://wa.me/${WHATSAPP_NUMBER}?text=` + encodeURIComponent(message);

    window.open(whatsappUrl, "_blank");
  };

  return (
    <main className="min-h-screen bg-gradient-to-br from-gray-950 via-red-950 to-black px-4 py-8 text-white sm:px-6 md:py-12">
      <div className="mx-auto w-full max-w-xl">
        {/* Back */}
        <Link
          to="/"
          className="mb-6 inline-flex items-center gap-2 text-sm font-semibold text-gray-400 transition hover:text-white"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to Home
        </Link>

        {/* Header */}
        <div className="mb-7 text-center">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl border border-yellow-400/20 bg-yellow-400/10">
            <Trophy className="h-8 w-8 text-yellow-400" />
          </div>

          <p className="mt-4 text-sm font-bold uppercase tracking-[0.3em] text-orange-400">
            BPL Season 2
          </p>

          <h1 className="mt-2 text-3xl font-black sm:text-4xl">
            Registration Payment
          </h1>

          <p className="mt-2 text-sm text-gray-400">
            Complete your registration by paying the ₹150 fee.
          </p>
        </div>

        {/* Payment Card */}
        <div className="overflow-hidden rounded-3xl border border-white/10 bg-white/[0.06] shadow-2xl backdrop-blur-xl">
          {/* Amount */}
          <div className="bg-gradient-to-r from-red-700 to-orange-500 p-6 text-center">
            <p className="text-sm font-semibold text-red-100">
              Registration Fee
            </p>

            <div className="mt-1 flex items-center justify-center gap-1">
              <IndianRupee className="h-8 w-8" />

              <span className="text-5xl font-black">150</span>
            </div>
          </div>

          <div className="p-6 sm:p-8">
            {/* Player Info */}
            <div className="mb-6 rounded-xl border border-white/10 bg-black/20 p-4">
              <div className="flex justify-between gap-4">
                <div>
                  <p className="text-xs uppercase tracking-wider text-gray-500">
                    Player
                  </p>

                  <p className="mt-1 font-bold">{playerName}</p>
                </div>

                <div className="text-right">
                  <p className="text-xs uppercase tracking-wider text-gray-500">
                    Player ID
                  </p>

                  <p className="mt-1 font-bold text-orange-400">#{id}</p>
                </div>
              </div>
            </div>

            {/* QR */}
            {/* QR Code */}
            <div className="flex justify-center">
              <div className="rounded-2xl bg-white p-5 shadow-xl">
                <QRCodeSVG value={upiUrl} size={250} level="H" includeMargin />
              </div>
            </div>

            <p className="mt-5 text-center text-sm text-gray-400">
              Scan this QR code with any UPI app
            </p>

            {/* Direct UPI Payment */}
            <button
              type="button"
              onClick={openUPIPayment}
              className="mt-6 w-full overflow-hidden rounded-2xl bg-white p-[1px] shadow-xl transition-all duration-300 hover:-translate-y-0.5 hover:shadow-2xl"
            >
              <div className="flex items-center justify-between rounded-[15px] bg-[#0757c9] px-5 py-4">
                {/* UPI Branding */}
                <div className="flex items-center gap-3">
                  <div className="flex h-10 w-14 items-center justify-center rounded-lg bg-white">
                    <img
                      src="/upi-logo.jpeg"
                      alt="UPI"
                      className="h-7 w-auto object-contain"
                    />
                  </div>

                  <div className="text-left">
                    <p className="text-base font-bold text-white">Pay ₹150</p>

                    <p className="text-xs text-blue-100">Using any UPI app</p>
                  </div>
                </div>

                {/* Arrow */}
                <div className="flex h-9 w-9 items-center justify-center rounded-full bg-white/15">
                  <svg
                    className="h-5 w-5 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </div>
              </div>
            </button>

            <p className="mt-3 text-center text-xs text-gray-500">
              PhonePe • Google Pay • Paytm • BHIM • Other UPI Apps
            </p>

            {/* UPI Details */}
            <div className="mt-6 rounded-2xl border border-white/10 bg-black/30 p-5">
              <p className="text-xs font-semibold uppercase tracking-wider text-gray-500">
                Pay To
              </p>

              <p className="mt-1 text-lg font-bold">{PAYEE_NAME}</p>

              <div className="mt-4">
                <p className="text-xs font-semibold uppercase tracking-wider text-gray-500">
                  UPI ID
                </p>

                <div className="mt-2 flex items-center justify-between gap-3">
                  <span className="break-all text-sm font-semibold text-orange-400">
                    {UPI_ID}
                  </span>

                  <button
                    type="button"
                    onClick={copyUPI}
                    className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-white/10 transition hover:bg-white/20"
                    title="Copy UPI ID"
                  >
                    {copied ? (
                      <Check className="h-5 w-5 text-green-400" />
                    ) : (
                      <Copy className="h-5 w-5 text-gray-300" />
                    )}
                  </button>
                </div>
              </div>
            </div>

            {/* Payment Instructions */}
            <div className="mt-6 rounded-xl border border-yellow-400/10 bg-yellow-400/5 p-4">
              <p className="text-sm font-bold text-yellow-300">
                Payment Instructions
              </p>

              <ol className="mt-2 list-decimal space-y-1 pl-5 text-xs leading-5 text-gray-400">
                <li>Scan the QR code using any UPI app.</li>
                <li>Pay exactly ₹150.</li>
                <li>Complete the payment successfully.</li>
                <li>Click the WhatsApp button below.</li>
              </ol>
            </div>

            {/* WhatsApp */}
            <button
              type="button"
              onClick={sendWhatsApp}
              className="mt-6 flex w-full items-center justify-center gap-3 rounded-xl bg-green-600 py-4 font-bold text-white shadow-lg transition hover:bg-green-500"
            >
              <MessageCircle className="h-5 w-5" />
              Send Payment Details on WhatsApp
            </button>

            {/* Verification */}
            <div className="mt-5 flex items-start gap-3 rounded-xl border border-green-500/20 bg-green-500/5 p-4">
              <ShieldCheck className="mt-0.5 h-5 w-5 shrink-0 text-green-400" />

              <p className="text-xs leading-5 text-gray-400">
                Your registration will remain pending until the BPL admin
                verifies your ₹150 payment.
              </p>
            </div>
          </div>
        </div>

        <p className="mt-5 text-center text-xs text-gray-600">
          BPL Season 2 • Badgaw Premier League
        </p>
      </div>
    </main>
  );
}
